import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Label } from '@wilson/interfaces';
import { LabelsModule } from '@wilson/labels';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';

@Component({
  selector: 'wilson-training-qualifications-general-section',
  imports: [
    FormsModule,
    NzCollapseModule,
    NzFormModule,
    NzInputModule,
    NzSelectModule,
    NzSwitchModule,
    ReactiveFormsModule,
    TranslatePipe,
    LabelsModule,
  ],
  templateUrl: './training-qualifications-general-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainingQualificationsGeneralSectionComponent {
  @Input() nameFormControl: FormControl<string | null> = new FormControl<
    string | null
  >(null, [Validators.required, Validators.maxLength(100)]);

  @Input() labelsFormControl: FormControl<Label[] | null> = new FormControl<
    Label[] | null
  >(null);

  protected Validators = Validators;
}
